import { useWeapons } from '../hooks/useWeapons';

/**
 * Ícone de categoria: a arte oficial de um item real daquele tipo, escolhida
 * pelo backend a partir do catálogo.
 *
 * Enquanto o catálogo não carregou (ou se a imagem falhar), cai para um emoji
 * neutro — melhor um marcador simples que um desenho mal-acabado.
 */
const FALLBACK: Record<string, string> = {
  all: '🏅',
  rifle: '🔫',
  sniper: '🎯',
  pistol: '🔫',
  smg: '🔫',
  shotgun: '🔫',
  machinegun: '🔫',
  knife: '🔪',
  gloves: '🧤',
  equipment: '⚡',
  sticker: '🏷️',
  charm: '🔗',
  agent: '🕵️',
  case: '📦',
  musickit: '🎵',
  patch: '🩹',
  graffiti: '🎨',
  key: '🔑',
  collectible: '🏅',
  other: '✦',
};

export function KindIcon({ kind, size = 32 }: { kind: string; size?: number }) {
  const { kindIcon } = useWeapons();
  const url = kindIcon(kind);

  if (!url) {
    return (
      <span className="kind-icon fallback" style={{ fontSize: size * 0.6, lineHeight: `${size}px` }} aria-hidden>
        {FALLBACK[kind] ?? FALLBACK.other}
      </span>
    );
  }

  return (
    <img
      className="kind-icon"
      src={url}
      width={size * 1.5}
      height={size}
      alt=""
      aria-hidden
      onError={(e) => {
        e.currentTarget.style.visibility = 'hidden';
      }}
    />
  );
}
